import { render } from "./PlayerManagementView.vue?vue&type=template&id=536f4646"
import script from "./PlayerManagementView.vue?vue&type=script&lang=js"
export * from "./PlayerManagementView.vue?vue&type=script&lang=js"

import "./PlayerManagementView.vue?vue&type=style&index=0&id=536f4646&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__